import React from 'react'
import {Marketplace} from 'js/types/marketplace'
import MarketplaceHeader from '../Marketplace/MarketplaceHeader'

interface Props {
  marketplace: Marketplace
  accountType: string
}

const toPlanDescription = (accountType: string) => {
  if (accountType === 'pay_as_you_go') {
    return 'Usage-Based Plan subscription'
  } else if (accountType == 'contract') {
    return 'Contract Plan'
  } else {
    return 'Plan'
  }
}

const SpinnerHeader = ({marketplace, accountType}: Props): JSX.Element => {
  const planDescription = toPlanDescription(accountType)

  switch (marketplace) {
    case 'aws':
      return (
        <MarketplaceHeader
          header="AWS Verification"
          subtitle={`We're waiting for Amazon to confirm the InfluxDB Cloud ${planDescription} is good to go`}
        />
      )
    case 'gcm':
      return (
        <MarketplaceHeader
          header="Google Cloud Verification"
          subtitle={`We're waiting for Google Cloud to confirm the InfluxDB Cloud ${planDescription} is good to go`}
        />
      )
  }
}

export default SpinnerHeader
